import {
    Component, OnInit, Directive, ElementRef,
    HostListener, HostBinding, Input, Output, Sanitizer,
    Compiler, NgModule, ViewChild, Renderer,
    ViewContainerRef
} from '@angular/core';
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Pipe, PipeTransform } from '@angular/core';
import { SurveyFormService } from '../_services/surveyFormService';
import { LowerCasePipe } from '@angular/common';
import * as $ from 'jquery';
import { QuestionInfo } from '../_models/Question';
import { TestInformation } from '../_models/Question';
import { FormsModule } from '@angular/forms';
import * as myGlobals from "../../globals";
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { NgClass, NgStyle } from '@angular/common';
import { Http, HttpModule } from '@angular/http';
import { IUserResponseObject, ITestInfo } from '../_models/UserResponseObject';

const URL = myGlobals.appPath + '/Test/PlayTest.aspx/StoreFileData';
@Component({
    templateUrl: 'app.surveyform.html',

})
export class SurveyFormComponent implements OnInit {
    private static instance: SurveyFormComponent;
    @HostListener('window:beforeunload', ['$event'])
    SaveReponse($event) {
        this.SubmitForm(true);
    }

    UserResponseObject: any; testinfo: ITestInfo;
    formData: any; QItems: any; TestInfo: any; assessmentName: any = '';
    Test = new TestInformation(); public SectionDetails: any;
    public appPath = myGlobals.appPath;
    public activeSectionID: any; public targetSectionID: any;
    public isDisplaySubmitButton: boolean = true;
    public isDisplayNextButton: boolean = false;
    public ActiveSectionNumber: any;
    public SectionInfo: any = [];
    public previousSectionID: any;


    //private dynamicHolderExtraModules = [FormsModule];
    constructor(private surveyService: SurveyFormService, private compiler: Compiler,
        private slimLoadingBarService: SlimLoadingBarService) {
        this.Test.QuestionInfo = [];
        this.Test.QuestionList = [];
        this.Test.QuestionChildrens = [];

    }

    startLoading() {
        this.slimLoadingBarService.height = '4px';
        this.slimLoadingBarService.color = 'firebrick';
        this.slimLoadingBarService.start(() => {
            console.log('Loading complete');
        });
    }
    stopLoading() {
        this.slimLoadingBarService.stop();
    }
    completeLoading() {
        this.slimLoadingBarService.complete();
    }
    ngOnInit() {
        this.startLoading();
        $("#progress").show();
        this.LoadThemeCss();
        var slimDiv = $(".slim-loading-bar-progress")
        slimDiv.css("height", "4px");
        this.surveyService.GetFormQuestions().subscribe(result => {
            this.completeLoading();
            $("#progress").hide();
            var reponseData: any;
            reponseData = result;
            this.formData = JSON.parse(reponseData.d);
            this.QItems = this.formData.QuestionsData.lstQuestions;
            this.TestInfo = this.formData.QuestionsData.Preferences;
            this.SectionDetails = this.formData.QuestionsData.TestDetails.Sections;
            this.ConstructSectionOjects(this.SectionDetails);
            this.assessmentName = this.TestInfo.AssessmentName;
            this.activeSectionID = this.SectionDetails[0].SectionID;
        })

    }
    ConstructSectionOjects(SectionInfo) {
        try {
            for (var i = 0; i < SectionInfo.length; i++) {
                this.SectionInfo[SectionInfo[i].SectionID] = SectionInfo[i];
                if (i == 0) {
                    SectionInfo[i].spNo = i;
                    SectionInfo[i].epNo = SectionInfo[i].QuestionCount;
                    continue;
                }
                if (SectionInfo[i + 1] != null && SectionInfo[i].SectionOrder < SectionInfo[i + 1].SectionOrder) {
                    SectionInfo[i].spNo = SectionInfo[i - 1].epNo + 1;
                    SectionInfo[i].epNo = SectionInfo[i - 1].epNo + SectionInfo[i].QuestionCount;
                }
                else {
                    SectionInfo[i].spNo = SectionInfo[i - 1].epNo + 1;
                    SectionInfo[i].epNo = SectionInfo[i - 1].epNo + SectionInfo[i].QuestionCount;
                }

            }
            return SectionInfo;

        }
        catch (ex) { }
    }


    LoadThemeCss() {
        var CssFileList = []
        CssFileList.push("/" + this.appPath + "/src/app/SurveyForm/styles/formstyle.css");
        CssFileList.filter(function (obj) {
            var fileref = document.createElement('link');
            fileref.rel = 'stylesheet';
            fileref.href = obj;
            fileref.media = 'all';
            fileref.type = 'text/css';
            var x = document.getElementsByTagName('head')[0];
            x.appendChild(fileref);

        });
    }
    onSelect(Test, guid, obj, value) {
        obj.textbox = value;
    }
    ChangeTargetSetion(targetsectionid: any, isNextClick = false, isHeadTabClcik = false): void {
        $("#section" + targetsectionid).addClass("active");
        if (isNextClick) {
            $("#progress").show();
            this.GetQuestionUserResponseObject(this.QItems, this.Test.QuestionInfo, this.TestInfo.ScheduleDetailUserID, this.activeSectionID);
            this.surveyService.StoreFormQuestionsResponse(this.UserResponseObject).subscribe(result => {
                $("#progress").hide();
                $("#section" + this.activeSectionID).removeClass("active");
                this.previousSectionID = this.activeSectionID;
                if (!isHeadTabClcik)
                    targetsectionid = this.activeSectionID = this.GetTargetSectionId();
                else
                    this.activeSectionID = targetsectionid;
                $("#section" + targetsectionid).addClass("active");
                this.ISCheckLastSection();
                this.HidePreviousSectionQuestions();
                for (var i = this.SectionInfo[targetsectionid].spNo - 1; i <= this.SectionInfo[targetsectionid].epNo - 1; i++) {
                    var questionDiv = $("#_" + this.Test.QuestionChildrens[i]);
                    $(questionDiv).css("display", "block");
                    var emdededtype = $("#dvcontainer" + this.Test.QuestionChildrens[i]);
                    if (emdededtype.length > 0) $(emdededtype).show();
                }

            })
        }
        else {
            if (this.SectionInfo[targetsectionid].spNo == 0) {
                for (var i = this.SectionInfo[targetsectionid].spNo; i <= this.SectionInfo[targetsectionid].epNo - 1; i++) {
                    var questionDiv = $("#_" + this.Test.QuestionChildrens[i]);
                    $(questionDiv).css("display", "block");
                    var emdededtype = $("#dvcontainer" + this.Test.QuestionChildrens[i]);
                    if (emdededtype.length > 0) $(emdededtype).show();
                }
            }
            else {
                this.ISCheckLastSection();
                this.HidePreviousSectionQuestions();
                for (var j = this.SectionInfo[targetsectionid].spNo - 1; j <= this.SectionInfo[targetsectionid].epNo - 1; j++) {
                    var questionDiv = $("#_" + this.Test.QuestionChildrens[j]);
                    $(questionDiv).css("display", "block");
                    var emdededtype = $("#dvcontainer" + this.Test.QuestionChildrens[j]);
                    if (emdededtype.length > 0) $(emdededtype).show();
                }
            }
        }
    }
    ISCheckLastSection() {
        if (this.SectionInfo[this.activeSectionID].SectionOrder == this.SectionDetails.length) {
            this.isDisplayNextButton = false;
            this.isDisplaySubmitButton = true;
        }
        else {
            this.isDisplayNextButton = true;
            this.isDisplaySubmitButton = false;
        }

    }
    HidePreviousSectionQuestions() {
        if (this.previousSectionID != '' && typeof (this.previousSectionID) != 'undefined') {
            for (var i = this.SectionInfo[this.previousSectionID].spNo - 1; i <= this.SectionInfo[this.previousSectionID].epNo - 1; i++) {
                var questionDiv = $("#_" + this.Test.QuestionChildrens[i]);
                $(questionDiv).css("display", "none");
                var emdededtype = $("#dvcontainer" + this.Test.QuestionChildrens[i]);
                if (emdededtype.length > 0) $(emdededtype).hide();
            }
        }
    }
    GetTargetSectionId(): string {
        var targetSectionid = '';
        for (var i = 0; i < this.SectionDetails.length; i++) {
            if ($.parseJSON(this.SectionInfo[this.activeSectionID].SectionOrder + 1) == this.SectionDetails[i].SectionOrder)

                targetSectionid = this.SectionDetails[i].SectionID;
        }
        return targetSectionid;
    }
    ConstructQuestionJsonObject(item: any): any {
        try {

            switch (item.QType.toLocaleLowerCase()) {
                case "range":
                case "longtext":
                case "shorttext":
                case "website":
                case "email":
                case "date":
                case "file upload":
                    item.QuestionAttributes[0].options = [];
                    item.QuestionAttributes[0].options = JSON.parse(item.Choices[0].OptionsText)[0].Questionoptioninfo.Options;
                    break;
                case "multioption":
                    item.QuestionAttributes[0].options = [];
                    item.QuestionAttributes[0].options = JSON.parse(item.Choices[0].OptionsText)[0].Questionoptioninfo.Options;
                    break;
                case "embededsubtype":
                    var optionsArray = JSON.parse(item.Choices[0].OptionsText);
                    for (var i = 0; i < item.QuestionAttributes.length; i++) {
                        for (var op = 0; op < optionsArray.length; op++) {
                            if (item.QuestionAttributes[i].QuestionInfo.Ident == optionsArray[op].Questionoptioninfo.Ident) {
                                item.QuestionAttributes[i].options = [];
                                item.QuestionAttributes[i].FieldLabel = [];
                                item.QuestionAttributes[i].options = optionsArray[op].Questionoptioninfo.Options;
                                item.QuestionAttributes[i].FieldLabel = optionsArray[op].Questionoptioninfo.FieldLabel;
                            }
                        }
                    }
                    //item.QuestionAttributes[0].options=JSON.parse(item.Choices[0].OptionsText)[0].QuestionoptionInfo.Options;
                    break;
            }
        }
        catch (e) { }
    }
    AddFieldValues(type: any, item: any, questionObj: any, index: any, itemId: any) {
        var element = $("#dvcontainer" + itemId);
        switch (type) {
            case 1:
                for (var ch = 0; ch < item.QuestionAttributes.length; ch++)
                    questionObj.model[item.QuestionAttributes[ch].QuestionInfo.Ident].textbox = "";
                if ($("#multiplefield" + itemId).length > 0) {
                    $("#multiplefield" + itemId)[0].remove()
                    questionObj.multifieldHtml = questionObj.FieldLabelsHtmlwithoutButton + '<button class="btn btn-primary btn-form display-4" (click)="SaveFieldValues(this,Test,\'' + itemId + '\', \'' + index + '\')" style="display: block;" type="button">SAVE</button></div></div></div>';
                }
                else
                    questionObj.multifieldHtml = questionObj.FieldLabelsHtmlwithoutButton + '<button class="btn btn-primary btn-form display-4" (click)="SaveFieldValues(this,Test,\'' + itemId + '\', \'' + index + '\')" style="display: block;" type="button">SAVE</button></div></div></div>';
                var outerHtml = '<div type="Question" id="_' + itemId + '"  secid="' + item.section.SectionID + '"   style="display: block;" ciid="" audioid="">' + questionObj.multifieldHtml + '</div>';
                questionObj.multifieldHtml = outerHtml;
                this.addComponent(element, questionObj.multifieldHtml, this);
                break;
            case 2:
                this.buildEditHtml(item, index, questionObj);
                if ($("#multiplefield" + itemId).length > 0)
                    $("#multiplefield" + itemId)[0].remove();
                questionObj.multifieldHtml = questionObj.FieldLabelsHtmlwithoutButton + '<button class="btn btn-primary btn-form display-4" (click)="UpdateFieldValues(this,Test,\'' + itemId + '\', \'' + index + '\')" style="display: block;" type="button">UPDATE</button></div></div></div>';
                var outerHtml = '<div type="Question" id="_' + itemId + '" secid="' + item.section.SectionID + '"  style="display: block;" ciid="" audioid="">' + questionObj.multifieldHtml + '</div>';
                questionObj.multifieldHtml = outerHtml;
                this.addComponent(element, questionObj.multifieldHtml, this);
                break;

        }

    }
    onInput($event) {
        $event.preventDefault();
    }
    buildEditHtml(item, index, questionObj) {
        var dataObj = questionObj.Data.filter(function (obj) {
            if (obj.currentIndex == index) return obj;
        })
        var quesText = item.Text;
        var QuestionDiv = "", formDiv = "", multiFieldsGridDiv = "";
        multiFieldsGridDiv = ''; let responseObj: any = dataObj[0]; let value: any;
        for (var ch = 0; ch < item.QuestionAttributes.length; ch++) {

            if (responseObj[item.QuestionAttributes[ch].QuestionInfo.Ident] != 'undefined' && responseObj[item.QuestionAttributes[ch].QuestionInfo.Ident].length > 0)
                questionObj.model[item.QuestionAttributes[ch].QuestionInfo.Ident].textbox = responseObj[item.QuestionAttributes[ch].QuestionInfo.Ident];

            switch (item.QuestionAttributes[ch].QuestionInfo.Type.toLocaleLowerCase()) {

                case "shorttext":
                    switch (item.QuestionAttributes[ch].QuestionInfo.ControlType.toLocaleLowerCase()) {
                        case "string":
                        case "alphanumeric":
                            item.Text = '<div class="md-form"><label class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + '</label>' + '<input type="text"   name="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox" class="form-control"   [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox" (keyup.enter)="keytab(2,$event)"   (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.ControlType + '\' ' + ',$event)"/></div>';
                            break;
                        case "password":
                            item.Text = '<div class="md-form"><label class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + '</label>' + '<input type="password"   name="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox" class="form-control"   [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox"  (keyup.enter)="keytab(2,$event)" (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.ControlType + '\' ' + ',$event)"/></div>';
                            break;
                        case "numeric":
                        case "number":
                            item.Text = '<div class="md-form"><label class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + '</label>' + '<input type="text"   name="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox" class="form-control"   [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox"  (keyup.enter)="keytab(2,$event)"   (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.ControlType + '\' ' + ',$event)"/></div>';
                            break;
                        case "date":
                            item.Text = '<div class="md-form"><label class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + '</label>' + '<input type="date"   name="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox" class=\"datepicker\"    [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox"  (keyup.enter)="keytab(2,$event)"  (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.ControlType + '\' ' + ',$event)"/></div>';
                            break;
                    }
                    break;
                case "date":
                    item.Text = '<div class="md-form"><label class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + '</label>' + '<input type="date"   name="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox" class=\"datepicker\"    [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox"  (keyup.enter)="keytab(2,$event)"  (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.ControlType + '\' ' + ',$event)"/></div>';
                    break;
                case "email":
                    item.Text = '<div class="md-form"><label class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + '</label>' + '<input type="email"   name="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox" class="form-control"   [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox" (keyup.enter)="keytab(2,$event)"   (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.ControlType + '\' ' + ',$event)"/></div>';
                    break;
                case "longtext":
                    item.Text = '<div class="md-form"><label class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + '</label>' + '<textarea class="form-control textarea" style="height: 104px;"   name="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox" class="form-control"   [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].textbox"  (keyup.enter)="keytab(2,$event)" (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.ControlType + '\' ' + ',$event)"></textarea></div>';
                    break;
                case "range":
                    item.Text = '<div class="md-form"><label class="lbquestion">' + item.Text + '</label>' + '<input type="range" min="' + item.QuestionAttributes[ch].options[0].optionText + '" max="' + item.QuestionAttributes[ch].options[1].optionText + '" step="any"    name="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.ID + '\'].textbox" class="form-control"   [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.ID + '\'].textbox"  (keyup.enter)="keytab(1,$event)"  (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Type + '\' ' + ',$event)"/>' +
                        '<output>{{Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.ID + '\'].textbox}}</output></div>';
                    break;
                case "multipleoptions":
                case "dropdown":
                    item.Text = '<div class="md-form"><label class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + '</label>' +
                        '<select (change)="onSelect(Test,\'' + item.ID + '\',Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'],$event.target.value)" (keyup.enter)="keytab(2,$event)"  class="form-control" [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].selectedOption"> ';
                    var optionHtml = "";
                    for (var op = 0; op < item.QuestionAttributes[ch].options.length; op++)
                        optionHtml = optionHtml + '<option>' + item.QuestionAttributes[ch].options[op].optionText + '</option>';
                    item.Text = item.Text + optionHtml + '</select></div>';
                    break;
                case "multioption":
                    switch (item.QuestionAttributes[ch].QuestionInfo.ControlType.toLocaleLowerCase()) {
                        case "dropdown":
                            item.Text = '<div class="md-form"><label class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + '</label>' +
                                '<select (change)="onSelect(Test,\'' + item.ID + '\',Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'],$event.target.value)" (keyup.enter)="keytab(2,$event)" class="form-control" [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].selectedOption"> ';
                            var optionHtml = "";
                            for (var op = 0; op < item.QuestionAttributes[ch].options.length; op++)
                                optionHtml = optionHtml + '<option>' + item.QuestionAttributes[ch].options[op].optionText + '</option>';
                            item.Text = item.Text + optionHtml + '</select></div>';
                            break;
                        case "radio":
                            item.Text = '<div class="md-form"><label  class="lbquestion">' + item.QuestionAttributes[ch].FieldLabel + ':</label>';
                            var optionHtml = "";
                            for (var op = 0; op < item.QuestionAttributes[ch].options.length; op++) {
                                optionHtml = optionHtml + '<label class="clslabelradio">' + item.QuestionAttributes[ch].options[op].optionText + '<input type="radio"   name="' + item.ID + '"  class="with-gap" [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\'].radioval" value="' + item.QuestionAttributes[ch].options[op].optionText + '" (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.ControlType + '\' ' + ',$event)"/></label>';
                            }
                            //optionHtml = optionHtml + '<option>' + item.QuestionAttributes[ch].options[op].optionText + '</option>';
                            item.Text = item.Text + optionHtml + '</div>';
                            break;
                        case "checkbox":
                            item.Text = '<div class="md-form"><label  class="lbquestion">' + item.Text + ':</label>';
                            var optionHtml = "";
                            for (var op = 0; op < item.QuestionAttributes[ch].options.length; op++) {
                                if (typeof (this.Test.QuestionInfo[item.ID].model[item.ID].checkboxtypevalues[item.QuestionAttributes[ch].options[op].optionId]) == 'undefined')
                                    this.Test.QuestionInfo[item.ID].model[item.ID].checkboxtypevalues[item.QuestionAttributes[ch].options[op].optionId] = { value: "" }
                                optionHtml = optionHtml + '<label class="clslabelradio">' + item.QuestionAttributes[ch].options[op].optionText + '<input type="checkbox"  id="' + item.ID + '"   [(ngModel)]="Test.QuestionInfo[\'' + item.ID + '\'].model[\'' + item.ID + '\'].checkboxtypevalues[\'' + item.QuestionAttributes[ch].options[op].optionId + '\'].value" name="' + item.ID + '" Ident="' + item.QuestionAttributes[ch].options[op].optionId + '" (ngModelChange)="mychange(this,\'' + item.ID + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.Ident + '\',\'' + item.QuestionAttributes[ch].QuestionInfo.ControlType + '\' ' + ',$event)"/></label>';;
                            }
                            item.Text = item.Text + optionHtml + '</div>';
                            break;
                    }
                    break;

            }
            formDiv = formDiv + item.Text;
            item.Text = null;
            if (ch == item.QuestionAttributes.length - 1) {
                QuestionDiv = '<div id="multiplefield' + item.ID + '" class="card childcard" style="width: 28rem;">' +
                    '<div class="card-body"> <!--Header-->' +
                    '<div class="form-header default-color">' +
                    '<h6><span class="mobile-hidden1">' + item.quesText + '</span>'
                    + '<button type="button" (click)="CloseFieldValues(\'' + item.ID + '\')" class="close" aria-label="Close">'
                    + '<span aria-hidden="true">×</span></button></h6>' +
                    '</div>' + formDiv +
                    `<div class="text-center"></div>
                                  </div>
                                  <!--Footer-->
                                    <div class="modal-footer"><div class="options"> <div>`;
                this.Test.QuestionInfo[item.ID].multifieldHtml = QuestionDiv;
                this.Test.QuestionInfo[item.ID].fieldsHtmlwithoutButton = QuestionDiv;

            }
        }
        return this.Test.QuestionInfo[item.ID];
    }
    DeleteFieldValues(questionObj: any, currentIndex: any, choiceObj: any) {
        questionObj.Data.forEach(function (item, index) {
            if (item.currentIndex == currentIndex) { questionObj.Data.splice(index, 1); }
        });

    }

    //Dynamic Template and component building
    //@ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;

    @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
    public addComponent(elementContainer, template: string, properties: any = {}) {
        @Component({ template })
        class TemplateComponent {
            //@ViewChild(elementContainer, { read: ViewContainerRef }) container: ViewContainerRef;           
            constructor(private surveyService: SurveyFormService) { }
            openFile(Test, itemid, event) {
                let questionObj = Test.Test.QuestionInfo[itemid]
                let input = event.target; let http: Http;
                var fileData = { content: '', name: '' }
                for (var index = 0; index < input.files.length; index++) {
                    fileData.name = input.files[index].name;
                    let reader = new FileReader();
                    reader.onload = () => {
                        // this 'text' is the content of the file
                        var text = reader.result;
                        fileData.content = btoa(text);
                        questionObj.isSuccess = true;
                    }
                    //  reader.readAsText(input.files[index]);
                    reader.readAsBinaryString(input.files[index]);
                    reader.onprogress = function (data) {

                        var progress = data.loaded / data.total * 100;
                        $('.progress-bar').css("width", progress + "%");
                        if (Number(progress) < 100) {
                            $(".badge").html(progress.toString() + "%");
                            questionObj.isUploading = true;
                            questionObj.progress = progress;
                        }
                        else if (Number(progress) == 100) {
                            questionObj.isUploading = false;
                            questionObj.progress = progress;
                            questionObj.isSuccess = true;
                            //this.ser StoreFileData
                            $('.progress-bar').css("width", progress + "%");
                            if (progress == 100) {
                                fileData.content = btoa((<any>data.target).result);
                                questionObj.fileData.push(fileData);

                            }
                        }
                    }

                };
            }
            SaveFileDataDB(Test, itemID) {
                var fileObj = Test.QuestionInfo[itemID].fileData[0];
                this.surveyService.StoreFileData(fileObj).subscribe(result => {
                    $(".badge").html("100%");
                    var reponseData: any;
                    reponseData = result;
                    reponseData = <any>reponseData.d;
                    if (reponseData.ResponseStatus.FPath == "") {
                        Test.QuestionInfo[itemID].model[itemID].isSuccess = false;
                        alert("Error uploading the file");
                        $(".badge").html("0%"); $(".progress-bar").css("width", "0%");
                        return false;
                    }
                    Test.QuestionInfo[itemID].ChoiceValues.push(reponseData.ResponseStatus.FPath);
                    Test.QuestionInfo[itemID].model[itemID].isSuccess = true;
                })
            }
            mychange(Test: any, modelId: any, val1: any, val2: any) {
                switch (val2.toLocaleLowerCase()) {
                    case "date":
                        break
                    case "number":
                    case "numeric":
                        var value = Number(Test.Test.QuestionInfo[modelId].model[val1].textbox)
                        if (value == null || typeof (value) == "string" || isNaN(value)) {
                            alert("Please enter only nummber");
                            $(event.currentTarget).val("");
                            Test.Test.QuestionInfo[modelId].model[val1].textbox = "";
                            return;
                        }
                        break;
                    case "string":
                        if (Test.Test.QuestionInfo[modelId].model[val1].textbox == '') {
                            Test.Test.QuestionInfo[modelId].model[val1].textbox = "";
                            $(event.currentTarget).val("");
                            alert("Please enter the field"); return;
                        }
                        break;

                }
            }
            CloseFieldValues(itemId) {
                $('#multiplefield' + itemId).hide();
            }
            defineProp(obj, key, value) {
                var config = {
                    value: value,
                    writable: true,
                    enumerable: true,
                    configurable: true
                };
                return Object.defineProperty(obj, key, config);
            }
            keytab(type: any, event: any) {
                let element;
                if (type == 1)
                    element = event.srcElement.parentElement.parentElement.nextElementSibling.children[0].children[1]
                else
                    element = event.srcElement.parentElement.nextElementSibling.children[1]; // get the sibling element
                if (element == null)  // check if its null
                    return;
                else
                    element.focus();   // focus if not null
            }
            UpdateFieldValues(thisobj, Test, guid, lastindex) {
                var obj = Test.QuestionInfo[guid];
                var tempObj = Object.create(Object.prototype);
                var columnscreated = false;
                for (var index in obj.model) {
                    for (var fi in obj.Data) {
                        if (obj.Data[fi].currentIndex == parseInt(lastindex)) {
                            if (!columnscreated) { obj.Data[fi].columns = []; columnscreated = true; }
                            obj.Data[fi].columns.push(obj.model[index].textbox + "$" + obj.model[index].fieldIdent);
                            Object.defineProperty(obj.Data[fi], obj.model[index].fieldIdent, {
                                enumerable: false,
                                configurable: false,
                                writable: false,
                                value: obj.model[index].textbox
                            });
                        }
                    }
                }
                if ($("#multiplefield" + guid).length > 0)
                    $("#multiplefield" + guid).hide()
            }
            SaveFieldValues(thisobj, Test, guid, lastindex) {
                var obj = Test.QuestionInfo[guid];
                var tempObj = Object.create(Object.prototype);
                for (var index in obj.model) {
                    for (var fi in obj.Data)
                        if (obj.Data[fi].currentIndex == parseInt(lastindex)) {
                            tempObj = this.defineProp(tempObj, obj.model[index].fieldIdent, "");
                            switch (obj.model[index].field.toLocaleLowerCase()) {
                                case "radio":
                                    obj.Data[fi].columns.push(obj.model[index].radioval + "$" + obj.model[index].fieldIdent);
                                    Object.defineProperty(obj.Data[fi], obj.model[index].fieldIdent, {
                                        enumerable: false,
                                        configurable: false,
                                        writable: false,
                                        value: obj.model[index].radioval
                                    });
                                    break;
                                case "checkbox":
                                    for (var checkindex in obj.model[index].checkboxtypevalues) {
                                        if (obj.model[index].checkboxtypevalues[checkindex].value) {
                                            obj.Data[fi].columns.push(checkindex + "$" + obj.model[index].fieldIdent);
                                            Object.defineProperty(obj.Data[fi], obj.model[index].fieldIdent, {
                                                enumerable: false,
                                                configurable: false,
                                                writable: false,
                                                value: obj.model[index].radioval
                                            });
                                        }
                                    }
                                    break;
                                default:
                                    obj.Data[fi].columns.push(obj.model[index].textbox + "$" + obj.model[index].fieldIdent);
                                    Object.defineProperty(obj.Data[fi], obj.model[index].fieldIdent, {
                                        enumerable: false,
                                        configurable: false,
                                        writable: false,
                                        value: obj.model[index].textbox
                                    });
                                    break;
                            }


                        }
                }

                tempObj = this.defineProp(tempObj, 'currentIndex', parseInt(lastindex) + 1);
                tempObj = this.defineProp(tempObj, 'columns', []);
                //   Object.defineProperty(Test.QuestionInfo[guid].emptydata,  'currentIndex', {
                //     enumerable: false,
                //     configurable: false,
                //     writable: false,
                //     value: lastindex +1
                //   });
                Test.QuestionInfo[guid].Data.push(tempObj)
                if ($("#multiplefield" + guid).length > 0)
                    $("#multiplefield" + guid).hide()

            }
            onSelect(Test, guid, obj, value) {
                obj.textbox = value;
            }
            AddFieldValues(type: any, index: any) {
                alert(index);

            }
            ChangeTargetSection(sectionId) {

            }
            ShowNext() {

            }

        }


        @NgModule({
            declarations: [TemplateComponent],
            imports: [BrowserModule, FormsModule]
        })
        class TemplateModule {

        }

        const mod = this.compiler.compileModuleAndAllComponentsSync(TemplateModule);
        const factory = mod.componentFactories.find((comp) =>
            comp.componentType === TemplateComponent
        );
        const component = this.container.createComponent(factory);
        Object.assign(component.instance, properties);
        // If properties are changed at a later stage, the change detection
        // may need to be triggered manually:
        component.changeDetectorRef.detectChanges();
    }


    GetQuestionUserResponseObject(QItems, QuestionList, suid, activeSectionID) {
        var moQuestionList = []; this.testinfo = { ScheduleDetailUserID: '', QuestionGUID: '' }
        this.UserResponseObject = {
            QuestionList: moQuestionList, AuditInfo: [],
            AuditList: [], TestInfo: this.testinfo
        }
        //Object Notation
        var defineProp = function (obj, key, value) {
            var config = {
                value: value,
                writable: true,
                enumerable: true,
                configurable: true
            };
            Object.defineProperty(obj, key, config);
        };
        var currentQuestionGuid = "", choiceIds = [], choiceValues = [], secitonID;

        QItems.filter(function (obj) {
            choiceIds = [], choiceValues = [];
            var monew = Object.create(Object.prototype);
            var currentQObj = QuestionList[obj.ID];
            secitonID = obj.section.SectionID;
            if (obj.QType.toLocaleLowerCase() == 'fileupload')
                choiceValues = currentQObj.ChoiceValues;
            if (currentQObj.ChoiceIDs.length == 1) {
                for (var ch in currentQObj.ChoiceIDs) {
                    switch (obj.QType.toLocaleLowerCase()) {
                        case "multioption":
                            currentQObj.ChoiceValues = [];
                            switch (obj.QuestionAttributes[ch].QuestionInfo.ControlType.toLocaleLowerCase()) {
                                case "dropdown":
                                    if (typeof (currentQObj.model[currentQObj.ChoiceIDs[ch]]) != 'undefined' && typeof (currentQObj.model[currentQObj.ChoiceIDs[ch]].textbox) != 'undefined' && currentQObj.model[currentQObj.ChoiceIDs[ch]].textbox != '') {
                                        currentQObj.ChoiceValues = [];
                                        currentQObj.ChoiceValues.push(currentQObj.model[currentQObj.ChoiceIDs[ch]].textbox);
                                    }
                                    else if (typeof (currentQObj.model[currentQObj.ChoiceIDs[ch]]) != 'undefined' && typeof (currentQObj.model[currentQObj.ChoiceIDs[ch]].selectedOption) != 'undefined') {
                                        currentQObj.ChoiceValues = [];
                                        currentQObj.ChoiceValues.push(currentQObj.model[currentQObj.ChoiceIDs[ch]].selectedOption);
                                    }
                                    break;
                                case "radio":
                                    currentQObj.ChoiceValues = [];
                                    currentQObj.choiceValues.push(currentQObj.model[currentQObj.ChoiceIDs[ch]].radioval);
                                    break;
                                case "checkbox":
                                    for (var checkindex in currentQObj.model[currentQObj.ChoiceIDs[ch]].checkboxtypevalues) {
                                        if (currentQObj.model[currentQObj.ChoiceIDs[ch]].checkboxtypevalues[checkindex].value)
                                            currentQObj.ChoiceValues.push(checkindex);
                                    }

                                    break;
                            }

                            break;

                        default:
                            if (typeof (currentQObj.model[currentQObj.ChoiceIDs[ch]]) != 'undefined' && typeof (currentQObj.model[currentQObj.ChoiceIDs[ch]].textbox) != 'undefined' && currentQObj.model[currentQObj.ChoiceIDs[ch]].textbox != '') {
                                currentQObj.ChoiceValues = [];
                                currentQObj.ChoiceValues.push(currentQObj.model[currentQObj.ChoiceIDs[ch]].textbox);
                            }
                            else if (typeof (currentQObj.model[currentQObj.ChoiceIDs[ch]]) != 'undefined' && typeof (currentQObj.model[currentQObj.ChoiceIDs[ch]].textbox) != 'undefined' && currentQObj.model[currentQObj.ChoiceIDs[ch]].textbox >= 0) {
                                currentQObj.ChoiceValues = [];
                                currentQObj.ChoiceValues.push(currentQObj.model[currentQObj.ChoiceIDs[ch]].textbox);
                            }
                            break;
                    }

                }
            }
            else if (currentQObj.ChoiceIDs.length > 1) {
                for (var index in currentQObj.Data) {
                    if (currentQObj.Data[index].columns.length > 1) {
                        for (var ch in currentQObj.ChoiceIDs) {
                            choiceIds.push("R" + index + ":" + currentQObj.ChoiceIDs[ch]);
                            choiceValues.push(currentQObj.Data[index][currentQObj.ChoiceIDs[ch]]);
                        }
                    }
                }
            }
            defineProp(monew, 'QuestionType', obj.QType)
            defineProp(monew, 'IsDel', false)
            defineProp(monew, 'GUID', obj.ID)
            if (currentQObj.ChoiceIDs.length > 1) {
                defineProp(monew, 'ChoiceIDs', choiceIds)
                defineProp(monew, 'ChoiceValues', choiceValues)
            }
            else {
                defineProp(monew, 'ChoiceIDs', currentQObj.ChoiceIDs)
                defineProp(monew, 'ChoiceValues', currentQObj.ChoiceValues)
            }
            if (currentQObj.ChoiceValues.length > 0) {
                moQuestionList.push(monew);
                currentQuestionGuid = obj.ID;
            }
            else if (choiceValues.length > 0) {
                moQuestionList.push(monew);
                currentQuestionGuid = obj.ID;
            }
        })
        try {
            this.UserResponseObject.QuestionList = moQuestionList;
            this.UserResponseObject.SectionList = [];
            this.UserResponseObject.AuditList = [];
            this.UserResponseObject.TestInfo.ActiveSection = activeSectionID;
            this.UserResponseObject.TestInfo.QuestionGUID = currentQuestionGuid;
            this.UserResponseObject.TestInfo.ScheduleDetailUserID = suid;
        }
        catch (e) {
            console.log("GetStoreStateValues", e.message);
            this.UserResponseObject.AuditInfo = null;
            this.UserResponseObject.SectionList = null;
            this.UserResponseObject.QuestionList = null;
        }
        return this.UserResponseObject;
    }
    SubmitForm(isClosed = false) {
        this.startLoading();
        $("#progress").show();
        this.GetQuestionUserResponseObject(this.QItems, this.Test.QuestionInfo, this.TestInfo.ScheduleDetailUserID, this.activeSectionID);
        this.UserResponseObject.TestInfo.isClosed = isClosed;
        this.surveyService.StoreFormQuestionsResponse(this.UserResponseObject).subscribe(result => {
            console.log('Success' + result);
            $("#formcontainer").hide();
            $("#dvsuccess").show()
            this.stopLoading();
            $("#progress").hide();
            $(".myBreadcrumb").hide();
        })

    }
    GetUserResponse(QuestionAttributes, type: any, userresponse: any, choiceid: any) {
        var checkboxarray: any = []
        switch (type) {
            case "shorttext":
            case "longtext":
            case "number":
            case "numeric":
            case "date":
            case "email":
            case "radio":
            case "range":
                if (userresponse != null) {
                    for (var i = 0; i < userresponse.length; i++) {
                        if (userresponse[i] != null && choiceid == userresponse[i].split(":")[0]) {
                            return userresponse[i].split(":")[1]
                        }
                    }
                }
                break;
            case "multioption":
                switch (QuestionAttributes.ControlType.toLocaleLowerCase()) {
                    case "Dropdown":
                        if (userresponse != null) {
                            for (var i = 0; i < userresponse.length; i++) {
                                return userresponse[i].split(":")[0]
                            }
                        }
                        break;
                    case "checkbox":
                        if (userresponse != null) {
                            for (var i = 0; i < userresponse.length; i++) {
                                checkboxarray[userresponse[i].split(":")[1]] = { value: userresponse[i].split(":")[1] };
                            }
                            return checkboxarray;
                        }
                        return checkboxarray;
                }

                break;

        }
    }
    CloseForm() {
        window.close();
    }
}





// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/SurveyForm/app.surveyform.ts